import React, {useState} from "react";
import {Card, CardBody, Col, Form, FormGroup, Input, Label, Row, CardTitle} from 'reactstrap';
import {
    ButtonCancel,
    ButtonSubmit,
} from "../../../components/buttons/buttonsActions";
import { useForm } from "react-hook-form";

import {setViewMode, setLoading} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/eventx/categoryGenreActions";
import CategoryGenreLangs from "./_langs";
import {connect} from "react-redux";
import {FL_STATUS, FL_CODE} from "../../../components/i18n/formLabels";
import { INTERNATIONAL } from "../../../components/i18n/i18n";
import Switch from "react-bootstrap-switch";

const TypeAudienceForm = props => {
    const { editMode, disableInputs, domainObject } = props.formProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id

    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [status, setStatus] = useState(domainObject?.status || false);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: domainObject?.code,
            keyEs: domainObject?.keyEs,
            keyENG: domainObject?.keyENG
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                id: domainObject?.id,
                uid: domainObject?.uid,
                status: status,
                langs: langs,
                isEvent: true
            }
        };

        try{
            if (editMode) {
                let id = domainObject.id;

                props.update(id, dataRequest)
            } else {
                props.save(dataRequest)
            }
            closeForm()
        } catch (error) {
            console.log(error)
        }
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }

    return <>
        <Card style={{minWidth: '570px'}} >
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="3">
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text" name="code"
                                innerRef={register}
                                disabled={disableInputs}
                            />
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <Label>Key</Label>
                            <Input
                                type="text" name="keyEs"
                                innerRef={register}
                                disabled={disableInputs}
                            />
                        </Col>
                        <Col md="3">
                            <Label>Key English</Label>
                            <Input
                                type="text" name="keyENG"
                                innerRef={register}
                                disabled={disableInputs}
                            />
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{INTERNATIONAL}
                    </CardTitle>
                    <CardBody>
                        <CategoryGenreLangs langs={langs} setLangs={setLangs} />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>
    </>

}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(TypeAudienceForm)
